/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateDrugBatchCommand } from '../models/CreateDrugBatchCommand';
import type { DrugBatchDetailDtoResponse } from '../models/DrugBatchDetailDtoResponse';
import type { DrugBatchDtoListResponse } from '../models/DrugBatchDtoListResponse';
import type { DrugBatchDtoResponse } from '../models/DrugBatchDtoResponse';
import type { UpdateDrugBatchCommand } from '../models/UpdateDrugBatchCommand';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class DrugBatchesService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @param drugId
     * @param status
     * @param search
     * @returns DrugBatchDtoListResponse Success
     * @throws ApiError
     */
    public getApiDrugBatchesDrugBatches(
        drugId?: string,
        status?: string,
        search?: string,
    ): CancelablePromise<DrugBatchDtoListResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/DrugBatches/DrugBatches',
            query: {
                'DrugId': drugId,
                'Status': status,
                'Search': search,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Server Error`,
            },
        });
    }
    /**
     * @param batchId
     * @returns DrugBatchDetailDtoResponse Success
     * @throws ApiError
     */
    public getApiDrugBatchesDrugBatchById(
        batchId: string,
    ): CancelablePromise<DrugBatchDetailDtoResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/DrugBatches/DrugBatchById/{batchId}',
            path: {
                'batchId': batchId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Server Error`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns DrugBatchDtoResponse Success
     * @throws ApiError
     */
    public postApiDrugBatchesCreateDrugBatch(
        requestBody?: CreateDrugBatchCommand,
    ): CancelablePromise<DrugBatchDtoResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/DrugBatches/CreateDrugBatch',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Server Error`,
            },
        });
    }
    /**
     * @param batchId
     * @param requestBody
     * @returns DrugBatchDtoResponse Success
     * @throws ApiError
     */
    public putApiDrugBatchesUpdateDrugBatch(
        batchId: string,
        requestBody?: UpdateDrugBatchCommand,
    ): CancelablePromise<DrugBatchDtoResponse> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/DrugBatches/UpdateDrugBatch/{batchId}',
            path: {
                'batchId': batchId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Server Error`,
            },
        });
    }
}
